import type {RoleSchema} from "../types";

const DISPATCH_ROLE_NAMES = new Set(["dispatch", "dispatch supervisor"]);

export function isDispatchRole(
  role: Pick<RoleSchema, "name"> | null | undefined,
): boolean {
  if (!role?.name) return false;
  return DISPATCH_ROLE_NAMES.has(role.name.trim().toLowerCase());
}

export function roleRequiresDispatchCenter(
  role: Pick<RoleSchema, "name"> | null | undefined,
): boolean {
  return isDispatchRole(role);
}
